import React from 'react';
import { Box, Typography } from '@mui/material';
import AvailabilitySchedule from '../../assets/images/availability_schedule.svg';
import PaymentSchedule from '../../assets/images/payment_schedule.svg';
import ConfirmationSchedule from '../../assets/images/confirmation_schedule.svg';

const StepperSchedule = ({ currentStep = 1 }) => {
  const steps = [
    { icon: AvailabilitySchedule, label: 'Disponibilidade' },
    { icon: PaymentSchedule, label: 'Pagamento' },
    { icon: ConfirmationSchedule, label: 'Confirmação' }
  ];

  return (
    <Box sx={{ 
      maxWidth: '500px',
      mx: 'auto',
      mb: 6,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
      px: 2
    }}>
      <Box sx={{
        position: 'absolute',
        top: '25%',
        left: '65px',
        right: '65px',
        height: 2,
        bgcolor: '#012F47',
        zIndex: 0
      }} />

      {steps.map((step, index) => (
        <Box 
          key={step.label}
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            zIndex: 1,
            position: 'relative'
          }}
        >
          {index + 1 === currentStep ? (
            // Ícone ativo
            <Box sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: '#012F47',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2
            }}>
              <Box 
                component="img"
                src={step.icon}
                alt={step.label}
                sx={{ 
                  width: 24,
                  height: 24,
                  filter: 'brightness(0) saturate(100%) invert(100%)'
                }}
              />
            </Box>
          ) : (
            <Box 
              component="img"
              src={step.icon}
              alt={step.label}
              sx={{ 
                width: 48,
                height: 48,
                filter: 'grayscale(100%)',
                bgcolor: '#EBF1F3',
                borderRadius: '50%'
              }}
            />
          )}
          
          <Typography 
            sx={{ 
              color: index + 1 === currentStep ? '#012F47' : 'grey.500',
              fontSize: '0.875rem',
              mt: 1,
              fontWeight: 500
            }}
          >
            {step.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default StepperSchedule;